<template>
  <div class="references-section">
    <div
      class="references-section__reference margin references-section__grid-item"
    >
      <strong>
        {{ $t('general.references') }}
      </strong>
    </div>
    <div
      class="references-section__service-time margin references-section__grid-item"
      :class="serviceTimeBorderHandler(serviceTime)"
      >
      <strong class="mx-3">{{ $t('engineering.commutator-maintenance.service-time')}}</strong>
      <div class="references-section__fields-wrapper">
        <commutator-reference-field
          :field-name="remainingTimeTitleHandler(serviceTimeDays)"
          :status="serviceTimeDays.status"
          :field-value="formatValue(serviceTimeDays.value)"
        />
      </div>
    </div>
    <div class="references-section__commutations margin references-section__grid-item"
      :class="borderHandler(commutations)"
    >
      <strong class="mx-3">
        {{ $t('engineering.commutator-maintenance.commutations') }}
      </strong>
      <div class="references-section__fields-wrapper">
        <commutator-reference-field
          :field-name="remainingTimeTitleHandler(commutationsDays)"
          :field-value="formatValue(commutationsDays.value)"
          :status="commutationsDays.status"
        />
        <commutator-reference-field
          :field-name="$t('engineering.commutator-maintenance.daily-average')"
          :field-value="commutations.dailyAverage"
        />
        <commutator-reference-field
          :field-name="operationsTitleHandler(commutationsOperations)"
          :field-value="formatValue(commutationsOperations.value)"
          :status="commutationsOperations.status"
        />
      </div>
    </div>
    <div class="references-section__i2pu-taxes margin references-section__grid-item"
      :class="borderHandler(i2pu)"
    >
      <i2pu
        class="references-section__i2pu-img"
      />
      <div class="references-section__fields-wrapper">
        <commutator-reference-field
          :field-name="remainingTimeTitleHandler(i2puDays)"
          :field-value="formatValue(i2puDays.value)"
          :status="i2puDays.status"
        />
        <commutator-reference-field
          is-exponential
          :field-name="$t('engineering.commutator-maintenance.daily-average')"
          :field-value="i2pu.dailyAverage"
        />
        <commutator-reference-field
          is-i2pu
          is-exponential
          :field-name="$t('engineering.commutator-maintenance.remaining')"
          :field-value="i2pu.remainingI2pu"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
 CompleteReferenceI2pu,
 BasicReference,
 CompleteReference,
 MaintenanceStatus,
} from 'sigma-mappings';
import I2pu from '@/domain/components/installation/engineering/commutatorMaintenance/I2pu';
import CommutatorReferenceField from './CommutatorReferenceField';

export default {
  name: 'NextMaintenanceSection',
  components: {
    CommutatorReferenceField,
    I2pu,
  },
  props: {
    references: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    collapsed: false,
  }),
  computed: {
    commutations() {
      const { commutations } = this.references;
      return commutations || new CompleteReference();
    },
    commutationsDays() {
      return (this.commutations.days || {});
    },
    commutationsOperations() {
      return (this.commutations.operations || {});
    },
    serviceTime() {
      const { serviceTime } = this.references;
      return serviceTime || new BasicReference();
    },
    serviceTimeDays() {
      return (this.serviceTime.days || {});
    },
    i2pu() {
      const { i2pu } = this.references;
      return i2pu || new CompleteReferenceI2pu();
    },
    i2puDays() {
      return (this.i2pu.days || {});
    },
  },
  methods: {
    formatValue(value) {
      if (value) {
        return value.toString().replace('-', '');
      }
      return value;
    },
    operationsTitleHandler(field = {}) {
      const { status, value } = field;
      if (!status) {
        return value < 0 ? this.$t('engineering.commutator-maintenance.overpassed-operations')
        : this.$t('engineering.commutator-maintenance.remaining-operations');
      }
      return status === MaintenanceStatus.DELAYED ? this.$t('engineering.commutator-maintenance.overpassed-operations')
        : this.$t('engineering.commutator-maintenance.remaining-operations');
    },
    remainingTimeTitleHandler(field = {}) {
      const { status, value } = field;
      if (!status) {
        return value < 0 ? this.$t('engineering.commutator-maintenance.delayed-days')
        : this.$t('engineering.commutator-maintenance.remaining-days');
      }
      return status === MaintenanceStatus.DELAYED ? this.$t('engineering.commutator-maintenance.delayed-days')
        : this.$t('engineering.commutator-maintenance.remaining-days');
    },
    borderHandler(reference = {}) {
      const { days, operations } = reference;
      const daysStatus = (days || {}).status;
      const operationsStatus = (operations || {}).status;
      const classes = {
        [MaintenanceStatus.DELAYED]: 'references-section__border-delayed',
        [MaintenanceStatus.IMMINENT]: 'references-section__border-imminent',
        [MaintenanceStatus.IN_DAY]: 'references-section__border-in-day',
      };
      return classes[daysStatus] || classes[operationsStatus] || '';
    },
    serviceTimeBorderHandler(reference = {}) {
      const { days } = reference;
      const daysStatus = (days || {}).status;
      const classes = {
        [MaintenanceStatus.DELAYED]: 'references-section__border-delayed',
        [MaintenanceStatus.IMMINENT]: 'references-section__border-imminent',
        [MaintenanceStatus.IN_DAY]: 'references-section__border-in-day',
      };
     return classes[daysStatus] || '';
    },
  },
};
</script>
<style lang="sass" scoped>
  @import "src/styles/defaults/mobile-first"

  .references-section
    position: relative
    height: 100%
    width: 100%
    border: 1px solid var(--color-tooltip-border)
    padding: 5px
    border-radius: 3px
    display: grid
    grid-column-gap: 5px
    grid-row-gap: 5px
    grid-template-columns: 1fr 1fr
    grid-template-rows: 1fr 2fr
    &__reference
      display: flex
      height: 100%
      width: 100%
      text-align: center
      align-items: center
      justify-content: center
      font-size: 1.1rem
      font-weight: bold
    &__service-time
      position: relative
      border-radius: 3px
      background: var(--color-background-dark)
    &__commutations
      position: relative
      border-radius: 3px
      background: var(--color-background-dark)
    &__fields-wrapper
      width: 100%
    &__i2pu-taxes
      position: relative
      border-radius: 3px
      display: flex
      align-items: flex-end
      background: var(--color-background-dark)
    &__i2pu-img
      position: absolute
      height: 30px
      width: 30px
      left: 5px
      top: 0
    &__border
      &-in-day
        border: 1.3px solid var(--color-primary)
      &-imminent
        border: 1.3px solid var(--color-warning)
      &-delayed
        box-shadow: 0 0 3px var(--color-danger-light),
        inset 0 0 3px var(--color-danger-light) !important

  @media screen
    +media-max-sm()
      .references-section
        grid-template-columns: 1fr
        &__grid-item:nth-child(1)
          order: 1
        &__grid-item:nth-child(2)
          order: 3
        &__grid-item:nth-child(3)
          order: 2
        &__grid-item:nth-child(4)
          order: 4
</style>

